type WaveDividerVariant = "benefits" | "trial";

const WAVE_PATHS: Record<WaveDividerVariant, [string, string, string]> = {
  benefits: [
    "M0 10 C 45 2, 90 18, 135 10 S 225 2, 270 10 S 315 18, 360 10",
    "M0 20 C 50 12, 100 28, 150 20 S 250 12, 300 20 S 330 28, 360 20",
    "M0 30 C 40 22, 80 38, 120 30 S 200 22, 240 30 S 300 38, 360 30",
  ],
  trial: [
    "M0 12 C 50 4, 95 20, 140 12 S 230 4, 275 12 S 320 20, 360 12",
    "M0 22 C 55 14, 105 30, 155 22 S 255 14, 305 22 S 335 30, 360 22",
    "M0 32 C 45 24, 85 40, 125 32 S 205 24, 245 32 S 310 40, 360 32",
  ],
};

type BenefitsWaveDividerProps = {
  variant?: WaveDividerVariant;
};

/** Three parallel undulating lines fading toward the right — section break under the headline. */
export function BenefitsWaveDivider({ variant = "benefits" }: BenefitsWaveDividerProps) {
  const gradientId = `${variant}-wave-fade`;
  const [topPath, midPath, bottomPath] = WAVE_PATHS[variant];

  return (
    <svg
      className="h-10 w-full shrink-0 text-[oklch(72%_0.09_155)]"
      viewBox="0 0 360 40"
      preserveAspectRatio="none"
      aria-hidden
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="currentColor" stopOpacity="0.85" />
          <stop offset="70%" stopColor="currentColor" stopOpacity="0.35" />
          <stop offset="100%" stopColor="currentColor" stopOpacity="0" />
        </linearGradient>
      </defs>

      <path
        d={topPath}
        fill="none"
        stroke={`url(#${gradientId})`}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d={midPath}
        fill="none"
        stroke={`url(#${gradientId})`}
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.75"
      />
      <path
        d={bottomPath}
        fill="none"
        stroke={`url(#${gradientId})`}
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.55"
      />
    </svg>
  );
}
